module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ir-c14862b9a48216f75d152bb010cebd45.svg";